

















































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import NavigationButtons from "./NavigationButtons.vue";
import { State, Action, Getter } from "vuex-class";
import { Workspace, ApplicationSubmit } from "@/entities";
import WorkflowButtons from "@/components/common/ProgressBar/WorkflowButtons.vue";
import { Utilities as _utils } from "@/shared/utilities";
import FileUpload from "./FileUpload.vue";
import FileDownload from '@/components/common/fileDownload/fileDownload.vue';
const namespace: string = "conceptNote";

@Component({
    components: {
        NavigationButtons,
        WorkflowButtons,
        FileUpload,
        FileDownload
    },
})
export default class DocumentChecklistComponent extends Vue {
    @Prop() model!: any;
    @Prop() readOnly: boolean;
    @Prop() isDirty!: boolean;
    @Prop() appId!: number;
    @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;
    @Getter("rootTemplate", { namespace }) rootSchema: any;
    @State(namespace) conceptNote!: Workspace;
    @Action("saveConceptNote", { namespace: "conceptNote" }) save: any;
    @Action("uploadDocument", { namespace }) uploadDocument: any;

    /** derived model to bind with the checklist */
    docCheckList: any = {};
    checklistKey: number = 0;
    checkStaffCVExist: any = {};
    additionalDocLoader = false;
    update = 0;
    mounted() {
        this.updateCheckList();
    }

    get workFlowItems() {
        return this.conceptNote.conceptNote.WorkflowInfo || {};
    }

    buttonAction(item) {
        this.conceptNote.conceptNote.WorkflowStatusId = item.StepId;
        this.conceptNote.conceptNote.Comments = item.Comments;
        this.conceptNote.conceptNote.Subject = item.Subject;
        this.conceptNote.conceptNote.notify = item.notify;

        return this.save({
            data: this.conceptNote.conceptNote,
            id: this.conceptNote.conceptNote.ConceptNoteId,
            context: "submit",
        }).then((success) => {
            if (success) {
                this.$router.push({
                    name: "dashboard",
                    query: {},
                });
            }
        });
    }
    updateCheckList() {
        const self = this;
        let schema: any = {};

        if (this.schema && this.schema.properties && this.schema.properties.mandatoryDocs) {
            schema = this.schema.properties;
        }

        if (this.appSubmit.checklist) {
            schema = this.appSubmit.checklist;
        }

        Object.keys(schema).forEach(section => {
            if (schema[section]["x-display"] === "checklist") {
                let checkListTypes = schema[section]["properties"];

                self.docCheckList = Object.keys(checkListTypes).reduce(
                    (chkList, key) => {
                        chkList[key] = {};
                        let docProperty = checkListTypes[key]["x-doc-key"];

                        if (checkListTypes[key]["type"] === "boolean") {
                            if (
                                self.model[docProperty] &&
                                Object.keys(self.model[docProperty]).length > 0
                            ) {
                                chkList[key].exists = true;
                                chkList[key] = Object.assign(
                                    chkList[key],
                                    self.model[docProperty]
                                );
                                chkList[key]["loading"] = false;
                            }
                        } else if (checkListTypes[key]["type"] === "array") {
                            const docPaths = docProperty.replace("[]", "").split(".");
                            if (docPaths.length === 2) {
                                const docModel = self.model[docPaths[0]];
                                if (docModel && docModel.length > 0) {
                                    chkList[key].exists = docModel
                                        .map((x) => x[docPaths[1]])
                                        .find((y) => y.name)
                                        ? true
                                        : false;
                                    chkList[key].docs =
                                        docModel.map((x) => x[docPaths[1]]).filter((x) => x.name) || [];
                                    chkList[key].isArray = true;
                                    if (chkList[key].docs) {
                                        chkList[key].docs.forEach((doc) => {
                                            doc["loading"] = false;
                                        });
                                    }
                                }
                            }
                        } else if (checkListTypes[key]["type"] === "object") {
                            Object.keys(checkListTypes[key]["properties"]).forEach(
                                (prop) => {
                                    if (
                                        checkListTypes[key]["properties"][prop].type ===
                                        "array"
                                    ) {
                                        const paths = checkListTypes[key]["properties"][
                                            prop
                                        ]["x-doc-key"]
                                            .replace("[]", "")
                                            .split(".");
                                        let items =
                                            checkListTypes[key]["properties"][prop][
                                            "items"
                                            ];
                                        const keys = Object.keys(items);
                                        let datum = _utils.clone(self.model[paths[0]] || []);
                                        this.checkStaffCVExist = datum;

                                        if (datum && datum.length > 0) {
                                            datum.map((x) => {
                                                x["keyList"] = [];
                                                keys.map((k) => {
                                                    if (typeof x[k] !== "object") {
                                                        x[k] = { value: x[k] };
                                                        x[k] = Object.assign(x[k], items[k]);
                                                    } else {
                                                        if (x[k] !== null)
                                                            x[k] = Object.assign(x[k], items[k]);
                                                        else x[k] = items[k];
                                                    }
                                                    x["keyList"].push(k);
                                                });
                                                x["doc"] = x[paths[1]];
                                                x["doc"]["loading"] = false;
                                                //x['loading']=false;
                                            });
                                            chkList[prop] = datum;
                                        }
                                    } else {
                                        docProperty =
                                            checkListTypes[key]["properties"][prop][
                                            "x-doc-key"
                                            ];
                                        chkList[prop] = {};
                                        if (
                                            self.model[docProperty] &&
                                            Object.keys(self.model[docProperty]).length > 0
                                        ) {
                                            chkList[prop].exists = true;
                                            chkList[prop] = Object.assign(
                                                chkList[prop],
                                                self.model[docProperty]
                                            );
                                            chkList[prop]["loading"] = false;
                                        }
                                    }
                                }
                            );
                        }
                        return chkList;
                    },
                    this.docCheckList
                );
            } else {
                this.addEmptyRow(section);
            }
        });

        // this.addEmptyRow();
    }

    get schema() {
        if (this.appSubmit.templates && this.appSubmit.templates.properties) {
            return this.appSubmit.templates.properties.checklist;
        } else {
            return {};
        }
    }

    addEmptyRow(key) {
        if (this.model && this.model[key]) {
            const emptyRow = this.model[key].find(
                (x) => Object.keys(x).length === 0
            );
            if (!emptyRow) {
                this.model[key].push({});
            }
        } else if (this.model) {
            this.model[key] = [{}];
        }
        this.checklistKey += 1;
    }

    onAddFiles(e, doc, sectionKey) {
        const { name, type, size } = e;
        this.uploadDocument({
            file: e,
            schema: {
                options: {
                    docTag: 41,
                },
            },
            transactionId: this.conceptNote.conceptNote.ConceptNoteId,
            language: this.$vuetify.lang.current,
        }).then((data) => {
            Object.assign(doc, data, { name, type, size });
            this.addEmptyRow(sectionKey);
            this.$emit("fileChange", doc);
        });
    }

    onRemoveFile(index, doc, sectionKey) {
        var self = this;

        if (doc.documentId) {
            this.$services.document.removeDocument(doc).then((data) => {
                self.model[sectionKey].splice(index, 1);
                this.addEmptyRow(sectionKey);
                this.$emit("fileChange", doc);
            });
        } else {
            self.model[sectionKey].splice(index, 1);
            this.addEmptyRow(sectionKey);
            this.$emit("fileChange", doc);
        }
    }

    submitSuccess(data) {
        if (data.Result == "OK") {
            this.$router.push({
                name: "dashboard",
                query: {},
            });
        }
    }

    @Watch("$route", { immediate: true, deep: true })
    onMenuChanged(route: any) {
        if (route.params.section === "submit") {
            this.updateCheckList();
            this.checklistKey += 1;
        }
    }
}
